
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/teachable-machine",
      function () {
        return require("private-next-pages/courses/teachable-machine.tsx");
      }
    ]);
  